import { db, type CNCDatabase } from './index';
import { TOS_VARNSDORF_WHNQ1315_TEMPLATE, DEFAULT_MACHINE } from '../data/defaultTemplates';

/**
 * Seed database with default machine (CNC-01) and default template (tpl_tos_whnq1315)
 * along with default workshop settings.
 */
export async function seedDatabase(targetDb?: CNCDatabase): Promise<void> {
  const database = targetDb || db;

  // 1. Seed Template
  const existingTemplate = await database.templates.get('tpl_tos_whnq1315');
  if (!existingTemplate) {
    console.log('[Seed] Seeding default template tpl_tos_whnq1315...');
    await database.templates.put(TOS_VARNSDORF_WHNQ1315_TEMPLATE);
  }

  // 2. Seed Default Machine
  const existingMachine = await database.machines.get('CNC-01');
  if (!existingMachine) {
    console.log('[Seed] Seeding default machine CNC-01 (TOS VARNSDORF WHN(Q) 13/15)...');
    await database.machines.put(DEFAULT_MACHINE);
  }

  // 3. Seed Default App Settings if missing
  const settingsCount = await database.settings.count();
  if (settingsCount === 0) {
    console.log('[Seed] Seeding default settings...');
    const now = new Date().toISOString();
    await database.settings.put({
      key: 'app_version',
      value: '1.0.0',
      updatedAt: now,
    });
    await database.settings.put({
      key: 'admin_pin_hash',
      value: '03ac674216f3e15c761ee1a5e255f067953623c8b388b4459e13f978d7c846f4', // Default PIN: 1234
      updatedAt: now,
    });
    await database.settings.put({
      key: 'workshop_name',
      value: 'CNC Precision Workshop',
      updatedAt: now,
    });
    await database.settings.put({
      key: 'line_config',
      value: {
        webhookUrl: '',
        apiToken: '',
        enabled: false,
      },
      updatedAt: now,
    });
    await database.settings.put({
      key: 'gas_config',
      value: {
        webAppUrl: '',
        enabled: false,
      },
      updatedAt: now,
    });
  }
}
